import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import FixelDataContext from "../../context/FixelDataContext";
import { StyledNavbar, StyledList, StyledTrialDaysCounter } from "./navbar.style";

const Navbar = () => {
  const { fullFixelData } = useContext(FixelDataContext);

  const isTrialExpired = () =>
      fullFixelData?.plan?.type?.toLowerCase() === "trial";

  const doesTrialHaveDays = () =>
      fullFixelData?.plan?.trial_days_remaining &&
      parseInt(fullFixelData.plan.trial_days_remaining) > 0 &&
      fullFixelData.state.toLowerCase() !== "terminated";

  const renderCounter = () => {
    let msg = "";
    if (doesTrialHaveDays()) {
      const days = fullFixelData.plan.trial_days_remaining;
      msg = `Your Fixel trial expires in ${days} ${days > 1 ? "days" : "day"}`;
    } else if (isTrialExpired()) {
      msg = `Your Fixel trial has expired`;
    }
    return <StyledTrialDaysCounter key="trialDaysCounter">{msg}</StyledTrialDaysCounter>;
  };

  return (
      <StyledNavbar>
        <StyledList>
          <li key="dashboard">
            <NavLink to="/dashboard">Dashboard</NavLink>
          </li>
          <li key="plans">
            <NavLink to="/plans">Plans</NavLink>
          </li>
          <li key="setup">
            <NavLink to="/setup">Settings</NavLink>
          </li>
          <li key="support">
            <NavLink to="/support">Support</NavLink>
          </li>
          {isTrialExpired() || doesTrialHaveDays() ? renderCounter() : null}
        </StyledList>
      </StyledNavbar>
  );
};
export default Navbar;
